<template>
  <div></div>
</template>

<script>
export default {
  name: "InputBase",
  data() {
    return {
      inputValue: "",
      focused: false,
      touched: false,
      id: ""
    };
  },
  props: {
    type: {
      default: "text",
      type: String
    },
    value: {
      default: ""
    },
    label: {
      default: "",
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    featured: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    validations: {
      default: () => {
        return [];
      },
      type: Array
    },
    bright: {
      default: false,
      type: Boolean
    }
  },
  components: {},
  methods: {
    emitValue(value) {
      this.$emit("update-value", value);
    },
    emitValidated(value) {
      this.$emit("validated", value);
    },
    setFocused(bool) {
      this.focused = bool;
    }
  },
  computed: {
    computedPlaceholder() {
      return this.focused ? "" : this.label;
    }
  },
  created() {
    if (this.value) {
      this.inputValue = this.value;
    }
    this.id = this.generateUuid();
  },
  watch: {
    inputValue() {
      this.touched = true;
    },
    value(newVal) {
      this.inputValue = newVal;
    }
  }
};
</script>
